import { render, staticRenderFns } from "./customersList.vue?vue&type=template&id=3230e406&scoped=true&"
import script from "./customersList.vue?vue&type=script&lang=js&"
export * from "./customersList.vue?vue&type=script&lang=js&"
import style0 from "./customersList.vue?vue&type=style&index=0&id=3230e406&lang=scss&scoped=true&"
import style1 from "./customersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230e406",
  null
  
)

export default component.exports